import React from "react";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import { ResponsiveLine } from "@nivo/line";

interface Props extends WithStyles<typeof styles> {
  data: any;
  xLabel: any;
  yLabel: any;
  colorSeries: any;
  textAnchor?: any;
}
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      overflow: "hidden",
      display: "flex",
    },
  });
class LHDLineGraphComponent extends React.Component<Props> {
  wrapType = (str: any): string => {
    if (str.length > 8) {
      // if string is longer than 16 characters
      var p = 8;
      while (p > 0) {
        // loop through the string and check each char
        if (str.charAt(p) === " " || str.charAt(p) === "-") {
          // if a dash or space is found, wrap the string
          var left =
            str.charAt(p) === "-"
              ? str.substring(0, p + 1)
              : str.substring(0, p);
          var right = str.substring(p + 1);
          return left + "\n" + this.wrapType(right); // return the wrapped string
        }
        p--;
      }
    }
    return str; // return the original string
  };
  HorizontalTick = (tick: any, textAnchor?: any) => {
    const MAX_LINE_LENGTH = 20;
    const MAX_LINES = 10;
    const LENGTH_OF_ELLIPSIS = 3;
    const TRIM_LENGTH = MAX_LINE_LENGTH * MAX_LINES - LENGTH_OF_ELLIPSIS;
    const trimWordsOverLength = new RegExp(`^(.{${TRIM_LENGTH}}[^\\w]*).*`);
    const groupWordsByLength = new RegExp(
      `([^\\s].{0,${MAX_LINE_LENGTH}}(?=[\\s\\W]|$))`,
      "gm"
    );
    const splitValues = tick.value
      .replace(trimWordsOverLength, "$1...")
      .match(groupWordsByLength)
      .slice(0, 2)
      .map((val: any, i: any) => (
        <tspan
          key={val}
          dy={20}
          x={0}
          style={{
            fontFamily: "sans-serif",
            fontSize: "10px",
          }}
        >
          {val}
        </tspan>
      ));
    return (
      <g transform={`translate(${tick.x},${tick.y}) rotate(325)`}>
        <text alignmentBaseline={tick.textBaseline} textAnchor={textAnchor}>
          {splitValues}
        </text>
      </g>
    );
  };

  getNormalToolTip = (point: any) => {
    let { yLabel } = this.props;
    return (
      <div>
        <div>
          <strong>{point.data.x}</strong>
        </div>
        <div
          key={point.id}
          style={{
            padding: "3px 0",
          }}
        >
          {`${point.data.y} ${yLabel}`}
        </div>
      </div>
    );
  };

  getRotateToolTip = (point: any) => {
    let { yLabel } = this.props;
    return (
      <div>
        <div>
          <strong>{`Temp: ${point.data.x} ºC`}</strong>
        </div>
        <div
          key={point.id}
          style={{
            padding: "3px 0",
          }}
        >
          {`${point.data.y} ${yLabel}`}
        </div>
      </div>
    );
  };

  getToolTip = (point: any, index: any) => {
    return (
      <div key={index.toString()}>
        <div
          key={point.id}
          style={{
            padding: "3px 0",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              borderRadius: 10,
              backgroundColor: point.serieColor,
              marginRight: 4,
            }}
          />
          {`${point.data.y.toFixed(2)}% ${point.serieId}`}
        </div>
      </div>
    );
  };

  render() {
    const { classes, data, colorSeries, textAnchor } = this.props;
    return (
      <div className={classes.root}>
        <ResponsiveLine
          data={data}
          margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: false,
            reverse: false,
          }}
          yFormat=" >-.2f"
          axisTop={null}
          axisRight={null}
          axisBottom={
            textAnchor
              ? {
                  tickRotation: -35,
                  orient: "bottom",
                  tickSize: 5,
                  tickPadding: 5,
                  legendOffset: 36,
                  legendPosition: "start",
                  renderTick: (tick) => this.HorizontalTick(tick, textAnchor),
                }
              : {
                  tickRotation: -35,
                  orient: "bottom",
                  tickSize: 5,
                  tickPadding: 5,
                  legendOffset: 36,
                  legendPosition: "start",
                }
          }
          axisLeft={{
            orient: "left",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Percentage (%)",
            legendOffset: -40,
            legendPosition: "middle",
          }}
          enableSlices={"x"}
          sliceTooltip={({ slice }) => {
            let toolTips = new Array<any>();
            slice.points.forEach((slicePoint: any, index: any) => {
              if (slicePoint.data) {
                toolTips.push(this.getToolTip(slicePoint, index));
              }
              return null;
            });
            return (
              <div
                style={{
                  background: "white",
                  padding: "9px 12px",
                  border: "1px solid #ccc",
                }}
              >
                {slice.points && slice.points.length > 0 && (
                  <div>
                    <strong>{slice.points[0].data.x}</strong>
                  </div>
                )}
                {toolTips}
              </div>
            );
          }}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabelYOffset={-12}
          colors={colorSeries}
          useMesh={true}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "rgba(0, 0, 0, .03)",
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
        />
      </div>
    );
  }
}
export default withStyles(styles)(LHDLineGraphComponent);
